import * as Sentry from "@sentry/react";
import { AuthCustomerUser } from "../api/models/unified";

export const clearUserFromSentry = () => {
  Sentry.setUser(null);
};

export const setUserToSentry = (user: AuthCustomerUser) => {
  Sentry.setUser(user);
};

export const setLanguageToSentry = (language: string) => {
  Sentry.setContext("language", { language });
};
